export default __webpack_public_path__ + "static/media/150cc1.f9b90175.jpg";